<template>
  <fin-cancel-onboarding-button id="cancel-onb-btn"
                                :class="`${$vuetify.breakpoint.mdAndUp ? 'ma-4 pa-0' : 'ma-3 pa-0'}`" :route="baseUrl" :callback="routeToLandingPage">
    <v-icon :size="20">icon-arrow-link-left</v-icon>
    Zurück zur Startseite
  </fin-cancel-onboarding-button>
</template>

<script>
import FinCancelOnboardingButton from '@/components/pages/onboarding/CancelOnboardingButton'
import {mapState} from 'vuex'
import BaseUrl from "@/mixins/BaseUrl"

export default {
  name: 'fin-registration-header',
  components: {FinCancelOnboardingButton},
  data() {
    return {
      baseUrl: '' // use empty string to avoid routing
    }
  },
  methods: {
    routeToLandingPage() {
      const a = document.createElement('a')
      a.href = 'https://fincraft.de'
      a.target = '_self'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  }
}
</script>

<style scoped>

</style>
